<ng-container *ngIf="breadcrumbs$ | async as breadcrumbs">
  <dgx-components-grid-container *ngIf="breadcrumbs.length > 1">
    <dgx-components-grid-row>
      <dgx-components-grid-column>
        <nav class="breadcrumbs">
          <ul class="breadcrumbs__list">
            <li
              *ngFor="let breadcrumb of breadcrumbs; let last = last"
              class="breadcrumbs__list-item"
            >
              <div *ngIf="!last; else breadcrumbLabel">
                <a
                  [routerLink]="breadcrumb.routerPath"
                  class="breadcrumbs__link"
                >
                  {{ breadcrumb.label }}
                </a>
                <dgx-components-icon
                  [name]="'chevron-right'"
                  [size]="'sm'"
                  class="breadcrumbs__icon"
                />
              </div>

              <ng-template #breadcrumbLabel
                >{{ breadcrumb.label }}
              </ng-template>
            </li>
          </ul>
        </nav>
      </dgx-components-grid-column>
    </dgx-components-grid-row>
  </dgx-components-grid-container>
</ng-container>
